import Decimal from 'decimal.js';

export class MathUtils {

  static roundDecimalCurrencyToCents(amount: Decimal): Decimal {
    if (amount === null || amount === undefined) {
      return new Decimal(0);
    }
    return amount.toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/math-utils.ts